// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_ZkA","cls2":"CollapsedActivityPreview-cls2_tv4 CollapsedActivityPreview-cls1_ZkA"};